import get from 'lodash/get';
import set from 'lodash/set';

export const nameSpace = window.YPS || window.Hatchly;

export const getViewData = (path, fallback) => {
    return get(nameSpace, path, fallback);
};

export const setViewData = (path, value) => {
    return set(nameSpace, path, value);
};
